import { MqDesktop, MqTablet } from 'streamr-ui/css/consts'
import styled from 'styled-components'

export const BaseSection = styled.div`
    --defaultPadding: 80px;

    max-width: 100%;
    overflow: hidden;
    padding: var(--defaultPadding, 160px) 0;

    & + & {
        padding-top: 56px;
    }

    h2,
    p {
        margin: 0;
    }

    h2 {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 32px;
    }

    p {
        font-size: 16px;
        line-height: 28px;
    }

    p + p {
        margin-top: 30px;
    }

    @media ${MqTablet} {
        --defaultPadding: 120px;

        h2 {
            font-size: 40px;
            line-height: 48px;
            margin-bottom: 48px;
        }

        p {
            font-size: 18px;
            line-height: 30px;
        }
    }

    @media ${MqDesktop} {
        --defaultPadding: 160px;

        h2 {
            font-size: 60px;
            line-height: 66px;
        }
    }
`
